export default __webpack_public_path__ + "static/stop-check-protect-5271ada5cba448495c2dcc0f16f95342.webp";